// extracted by mini-css-extract-plugin
module.exports = {"root":"Collections-module__root___2nYvU","show":"Collections-module__show___2IfSP","close":"Collections-module__close___3I3TT","title":"Collections-module__title___1as_x"};